import { feeCalculationUrls } from 'constants/apiEndPoints';
import ApiUtil from '../utils/ApiUtil';

const viewDailyFeeCalculationData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {

        ApiUtil.getWithToken(`${String(feeCalculationUrls.dailyFundFee)}?sortOrder=DESC&page=${page}&size=${size}`)
            .then((dailyFeeData) => {
                resolve(dailyFeeData);
            })
            .catch((error) => {
                reject(error);
            });


    })

const viewMonthlyFeeCalculationData = async (page: number, size: number): Promise<unknown> => await
    new Promise((resolve, reject) => {

        ApiUtil.getWithToken(`${String(feeCalculationUrls.monthlyFundFee)}?sortOrder=DESC&page=${page}&size=${size}`)
            .then((monthlyFeeData) => {
                resolve(monthlyFeeData);
            })
            .catch((error) => {
                reject(error);
            });
    })
const searchDailyFeeTable = async (data: {
    fundId: number, date: string, page: number, size: number,
    sortBy: string,
    sortOrder: string,
}): Promise<unknown> => await
        new Promise((resolve, reject) => {

            ApiUtil.postWithToken(`${String(feeCalculationUrls.searchDailyFeeTable)}`, data)
                .then((searchData) => {
                    resolve(searchData);
                })
                .catch((error) => {
                    reject(error);
                });
        })

const fetchFundLevelFees = async (data: {
    fundId: string, date: string, page: number, size: number,
    sortBy: string,
    sortOrder: string,
}): Promise<unknown> => await
        new Promise((resolve, reject) => {

            ApiUtil.postWithToken(`${String(feeCalculationUrls.fetchFundLevelFees)}`, data)
                .then((feeData) => {
                    resolve(feeData);
                })
                .catch((error) => {
                    reject(error);
                });
        })

const fetchMonthlyFundUnits = async (data: {
    day: number,
    month: string, year: string, fundId: string, page: number, size: number,
    sortBy: string,
    sortOrder: string,
    deductionType?: string;
}): Promise<unknown> => await
        new Promise((resolve, reject) => {

            ApiUtil.postWithToken(`${String(feeCalculationUrls.fetchMonthlyUnits)}`, data)
                .then((unitsData) => {
                    resolve(unitsData);
                })
                .catch((error) => {
                    reject(error);
                });
        })
export { viewMonthlyFeeCalculationData, viewDailyFeeCalculationData, searchDailyFeeTable, fetchFundLevelFees, fetchMonthlyFundUnits }